import styled from 'styled-components'

const ReportSummaryTitle = styled.div`
  color: #626262;
  font-size: 14px;
  font-weight: 500;
`

export default ReportSummaryTitle